<template>
  <div v-if="$store.state.start_time !== null && $store.state.end_time !== null">
    <h4 v-if="message !== ''">
      {{ message }}
    </h4>
    <div v-if="!ended" class="countdown-box">
      <div class="countdown">
        <div class="digits">
          {{ daysLeft }}
        </div>
        <div class="digits">
          {{ hoursLeft }}
        </div>
        <div class="digits">
          {{ minutesLeft }}
        </div>
        <div class="digits">
          {{ secondsLeft }}
        </div>
        <label>Days</label>
        <label>Hours</label>
        <label>Minutes</label>
        <label>Seconds</label>
      </div>
    </div>
    <div
      v-if="running"
      class="xp-level"
      title="How much of the CTF has passed"
    >
      {{ Math.floor(progress) }}%
    </div>
    <div v-if="running" class="progress">
      <div
        class="progress-bar"
        :style="{width: progress.toString() + '%'}"
      />
    </div>
    <div class="date-box" :style="{justifyContent: running ? 'space-between' : 'center'}">
      <div>{{ dateToISO($store.state.start_time) }}</div>
      <div v-if="!running">
        -
      </div>
      <div>{{ dateToISO($store.state.end_time) }}</div>
    </div>
  </div>
</template>

<script>
import { dateToISO } from '@/utilityFunctions.js'

export default {
    data () {
        return {
            daysLeft: 0,
            hoursLeft: 0,
            minutesLeft: 0,
            secondsLeft: 0,
            progress: 0,
            message: '',
            running: false,
            ended: false,
        }
    },
    mounted () {
        this.timerCount()
        this.interval = setInterval(() => { this.timerCount() }, 1000)
    },
    methods: {
        timerCount () {
            const startTime = this.$store.state.start_time
            const endTime = this.$store.state.end_time
            if (startTime === null || endTime === null) {
                return
            }

            const now = Date.now()
            this.running = startTime <= now && now <= endTime
            this.ended = now > endTime

            this.progress = Math.min(100, 100 * (now - startTime) / (endTime - startTime))

            let diffSeconds = (endTime - now) / 1000
            this.message = 'Time left:'
            if (now < startTime) {
                diffSeconds = (startTime - now) / 1000
                this.message = 'Time until start:'
            } else if (now > endTime) {
                this.message = 'The CTF is over!'
            } else if (this.progress >= 90) {
                this.message = 'The end is near...'
            }

            this.daysLeft = Math.max(0, Math.floor(diffSeconds / (60 * 60 * 24)))
            this.hoursLeft = Math.max(0, Math.floor((diffSeconds / (60 * 60)) % 24))
            this.minutesLeft = Math.max(0, Math.floor((diffSeconds / 60) % 60))
            this.secondsLeft = Math.max(0, Math.floor(diffSeconds % 60))
        },
        dateToISO,
    },
}
</script>

<style lang="scss" scoped>
h4 {
    text-align: center;
    padding-top: 0.25rem;
}
.countdown-box {
    display: flex;
    justify-content: center;
}
.countdown {
  display: grid;
  grid-template-columns: auto auto auto auto;
  column-gap: 1.5rem;
  text-align: center;
  .digits {
      font-size: 2.25rem;
      font-weight: 700;
      line-height: 1.25;
      min-width: 5rem;
  }
  label {
      color: $color-muted-text;
  }
}
@media only screen and (max-width: 575.98px) {
    .countdown {
        column-gap: 0.75rem;
        .digits {
            font-size: 1.6875rem;
            min-width: 0;
        }
        label {
            font-size: 0.75rem;
        }
    }
}
// Minecraft's experience bar, in the logo's colours.
.xp-level {
    margin-top: 1rem;
    text-align: center;
    color: #80ff20;
    font-weight: 700;
    text-shadow:
        2px 0 #000000,
        -2px 0 #000000,
        0 2px #000000,
        0 -2px #000000;
}
.progress {
    position: relative;
    flex: 1 0 auto;
    height: 14px;
    margin-top: 0.25rem;
    background-color: $ssm-field;
    border: $mc-px solid $ssm-field-border;
    overflow: hidden;

    // The notches between the bar's segments.
    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: repeating-linear-gradient(90deg, transparent 0 calc(5.555% - 2px), rgba(0, 0, 0, 0.55) calc(5.555% - 2px) 5.555%);
    }
}
.progress-bar {
    background: linear-gradient(90deg, $ssm-pink, $ssm-green, $ssm-cyan);
    height: 100%;
    transition: width 0.5s steps(4, end);
}
.date-box {
    display: flex;
    padding-top: 0.5rem;
    color: $color-muted-text;
    > div {
        margin: 0 5px 0 5px;
    }
}
</style>
